<template>
    <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.365 10.6749L22.0575 7.29491L19.7475 4.61991C19.3575 4.16991 18.795 3.90991 18.1975 3.90991C17.705 3.90991 17.23 4.08741 16.86 4.40991L4.57001 15.0624C3.72751 15.7924 3.62 17.0399 4.3275 17.9024L17.1125 33.5274L10.985 15.8249C10.2625 13.7374 11.31 11.4749 13.3675 10.6749H13.365Z"
            fill="white"
        />
        <path
            d="M32.645 11.25L31.415 8.05249C31.1125 7.26749 30.345 6.73999 29.505 6.73999C29.2525 6.73999 29.0025 6.78749 28.765 6.87999L14.105 12.58C13.075 12.98 12.5525 14.1125 12.9125 15.155L18.405 31.02V15.3375C18.405 13.0825 20.24 11.2475 22.495 11.2475H32.6425L32.645 11.25Z"
            fill="white"
        />
        <path
            d="M30.7925 21.1523C29.195 21.1523 27.9075 22.3023 27.9075 24.1223V26.2248C27.9075 27.9898 28.9725 29.1398 30.7925 29.1398C32.445 29.1398 33.735 27.8798 33.735 26.1698V24.1523C33.735 22.3873 32.39 21.1548 30.7925 21.1548V21.1523Z"
            fill="white"
        />
        <path
            d="M38.86 13.2949H22.4975C21.37 13.2949 20.4525 14.2124 20.4525 15.3399V38.8624C20.4525 39.9899 21.37 40.9074 22.4975 40.9074H38.86C39.9875 40.9074 40.905 39.9899 40.905 38.8624V15.3399C40.905 14.2124 39.9875 13.2949 38.86 13.2949ZM37.095 26.6449C37.095 30.0924 34.3775 32.2499 31.715 32.2499C30.2575 32.2499 28.7175 31.8299 28.0175 31.0999H27.905V36.8449H24.5425V18.2124H27.905V19.3324H28.0175C28.69 18.5474 30.175 18.0149 31.715 18.0149C34.5175 18.0149 37.095 20.3974 37.095 23.7024V26.6449Z"
            fill="white"
        />
    </svg>
</template>
